function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M37.432 13c-9.161.844-16.292 8.538-16.292 17.92v27.052c0 1.638 1.337 3.028 3.02 3.028h29.96c1.633 0 3.02-1.34 3.02-3.028V30.92c0-9.381-7.18-17.075-16.292-17.919"
}), React.createElement("path", {
  fill: "#C7D7E2",
  fillRule: "nonzero",
  d: "M40.615 5h-3.416c-.703.05-1.406.15-2.06.298 8.238 1.74 15.471 8.944 15.471 17.64v35.03c0 1.64-1.356 3.032-3.064 3.032h6.53c1.658 0 3.064-1.342 3.064-3.031V22.938c0-9.391-7.233-17.093-16.525-17.938z"
}), React.createElement("path", {
  fill: "#98BED8",
  fillRule: "nonzero",
  d: "M38.64 15a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M35.684 24c-.875 0-1.544-.67-1.544-1.544 0-2.985 2.419-5.456 5.456-5.456.875 0 1.544.67 1.544 1.544 0 .875-.67 1.544-1.544 1.544a2.361 2.361 0 0 0-2.368 2.368c0 .875-.72 1.544-1.544 1.544z"
}), React.createElement("path", {
  fill: "#98BED8",
  fillRule: "nonzero",
  d: "M38.64 34a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M35.684 43c-.875 0-1.544-.67-1.544-1.544 0-2.985 2.419-5.456 5.456-5.456.875 0 1.544.67 1.544 1.544 0 .875-.67 1.544-1.544 1.544a2.361 2.361 0 0 0-2.368 2.368c0 .875-.72 1.544-1.544 1.544zM11.64 51a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M53.674 63H23.655c-2.48 0-4.515-2.04-4.515-4.527V23.451c0-8.01 4.763-15.123 12.206-18.108C33.529 4.448 36.01 4 38.59 4h.1c2.63 0 5.06.448 7.244 1.343A19.46 19.46 0 0 1 58.14 23.451v35.072c0 2.437-1.985 4.477-4.466 4.477zM38.59 6.985c-2.233 0-4.316.398-6.152 1.144-6.252 2.537-10.321 8.556-10.321 15.372v35.072c0 .845.695 1.542 1.538 1.542h30.02c.843 0 1.488-.697 1.488-1.542V23.45c0-6.766-4.069-12.835-10.32-15.372-1.837-.746-3.92-1.144-6.153-1.144h-.1v.05z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M56.64 26a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M57.14 32c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M58.64 26.076c0-.477.248-.906.644-1.193l8.033-5.151c.694-.43 1.586-.239 2.082.381.446.668.248 1.527-.396 2.004l-8.033 5.151c-.694.43-1.586.239-2.082-.381-.149-.286-.248-.573-.248-.811z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M71.604 14.544a1.473 1.473 0 0 1-.549 2.049 2.006 2.006 0 0 0-.732 2.732 2.006 2.006 0 0 0 2.732.732 1.473 1.473 0 0 1 2.05.55 1.473 1.473 0 0 1-.55 2.048 5.015 5.015 0 0 1-6.83-1.83 5.015 5.015 0 0 1 1.83-6.83 1.473 1.473 0 0 1 2.05.549z"
}), React.createElement("path", {
  fill: "#C7D7E2",
  fillRule: "nonzero",
  d: "M53.704 58c-.89 0-1.534-.65-1.534-1.5s.643-1.5 1.485-1.5c.841 0 1.485.65 1.485 1.5s-.644 1.5-1.436 1.5zM49.2 58h-.05c-.84 0-1.484-.65-1.484-1.5s.643-1.5 1.485-1.5h.05c.84 0 1.484.65 1.484 1.5S49.991 58 49.2 58zm-4.505 0c-.89 0-1.534-.65-1.534-1.5s.643-1.5 1.485-1.5c.841 0 1.485.65 1.485 1.5s-.644 1.5-1.436 1.5zm-4.505 0h-.05c-.84 0-1.484-.65-1.484-1.5s.643-1.5 1.485-1.5h.05c.841 0 1.485.65 1.485 1.5S40.98 58 40.189 58zm-4.505 0c-.89 0-1.534-.65-1.534-1.5s.643-1.5 1.485-1.5c.842 0 1.485.65 1.485 1.5s-.643 1.5-1.436 1.5zm-4.504 0c-.892 0-1.535-.65-1.535-1.5s.643-1.5 1.485-1.5c.842 0 1.485.65 1.485 1.5S31.972 58 31.18 58zm-4.505 0h-.05c-.842 0-1.485-.65-1.485-1.5s.643-1.5 1.485-1.5h.05c.841 0 1.485.65 1.485 1.5s-.693 1.5-1.485 1.5z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M12.14 57c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M10.503 52a1.644 1.644 0 0 1-1.527-1L6.25 44.158c-.327-.79.11-1.737.927-2.053.873-.315 1.8.106 2.128.895l2.727 6.842c.327.79-.11 1.737-.928 2.053-.218.105-.381.105-.6.105z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M1.344 40.248a1.473 1.473 0 0 1 2.049.55 2.006 2.006 0 0 0 2.732.732 2.006 2.006 0 0 0 .732-2.733 1.473 1.473 0 0 1 .55-2.049 1.473 1.473 0 0 1 2.048.55 5.015 5.015 0 0 1-1.83 6.83 5.015 5.015 0 0 1-6.83-1.83 1.473 1.473 0 0 1 .549-2.05z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M20.64 38a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M21.14 45c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M13.585 52c-.283 0-.52-.099-.804-.247-.662-.445-.851-1.384-.378-2.076l5.109-8.007c.426-.692 1.324-.89 1.987-.395.662.444.851 1.383.378 2.075l-5.062 8.007a1.547 1.547 0 0 1-1.23.643z"
}), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#454B54",
  d: "M66.14 57.6c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 15.9c-.85 0-1.5-.65-1.5-1.5 0-1.1-.9-2-2-2s-2 .9-2 2c0 .85-.65 1.5-1.5 1.5s-1.5-.65-1.5-1.5c0-2.75 2.25-5 5-5s5 2.25 5 5c0 .85-.65 1.5-1.5 1.5z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M57.24 38.55a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M57.24 45.05c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm5.9 24.05c-.2 0-.35-.05-.55-.1-.75-.3-1.15-1.15-.85-1.95l2.5-6.5c.3-.75 1.15-1.15 1.95-.85.75.3 1.15 1.15.85 1.95l-2.5 6.5c-.25.6-.8.95-1.4.95z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M64.54 52.75c-.5 0-.95-.25-1.25-.65l-5.4-8.1c-.45-.7-.25-1.6.4-2.1.7-.45 1.6-.25 2.1.4l5.4 8.1c.45.7.25 1.6-.4 2.1-.3.15-.6.25-.85.25z"
})), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M52.048 67.11L48.347 62H29.94l-.964 1.313h1.927c.862 0 1.521.609 1.521 1.406 0 .797-.659 1.406-1.52 1.406h-3.956l-.71.984c-.253.375 0 .891.507.891h24.795c.456 0 .76-.516.507-.89zM39.69 6c-.849-.055-1.598-.763-1.548-1.69V1.584c0-.927.749-1.636 1.548-1.581.848 0 1.497.763 1.447 1.69v2.726c0 .872-.649 1.581-1.447 1.581zM35.69 7c-.849-.055-1.598-.763-1.548-1.69V2.584c0-.927.749-1.636 1.548-1.581.848 0 1.497.763 1.447 1.69v2.726c0 .872-.649 1.581-1.447 1.581zM43.69 7c-.849-.055-1.598-.763-1.548-1.69V2.584c0-.927.749-1.636 1.548-1.581.848 0 1.497.763 1.447 1.69v2.726c0 .872-.649 1.581-1.447 1.581z"
}));

var SvgChiefRobot = function SvgChiefRobot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 76,
    height: 69,
    viewBox: "0 0 76 69",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChiefRobot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chief-robot.318a7563.svg";
export { ForwardRef as ReactComponent };